import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Mouse = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M8 8.68a.333.333 0 0 1-.334-.333V4.681a.333.333 0 1 1 .667 0v3.666a.333.333 0 0 1-.334.334Z" />
      <path d="M8 16.346a5.333 5.333 0 0 1-5.334-5.333V6.347a5.333 5.333 0 0 1 10.666 0v4.666A5.333 5.333 0 0 1 8 16.346ZM8 1.68a4.667 4.667 0 0 0-4.667 4.667v4.666a4.667 4.667 0 0 0 9.333 0V6.347A4.666 4.666 0 0 0 7.999 1.68Z" />
    </svg>
  );
};

Mouse.category = 'product-category';

Mouse.displayName = 'Mouse';
